export const preloadCommonModules = async () => {
  try {
    // Only preload modules that are:
    // 1. Used across multiple components/pages
    // 2. Contain utilities that cause navigation errors
    // 3. Are small and lightweight
    await Promise.all([
      import('./commonUtilityServices'),
      import('./common.service'),
      import('./common.service2'),
      import('./createStorage'),
      import('../store/store'),
      import('../middleware/services/reimbusement/appeal/apiUrlConstants'),
      import('../CommonComponents/constant/constant'),
      import('@src/middleware/actions/Reimbursement/overPaymentActions'),
      import('@src/middleware/actions/exemptionAction/exmptionAction'),
      import('@src/middleware/actions/Ancillary/Labs/LabsAction'),
      import('@src/middleware/actions/ServiceInteraction/DigitalSolutions/smartEditsActions'),
      import('@src/middleware/actions/Reimbursement/reiumbursementTabDataAction'),
      import('@src/middleware/actions/Reimbursement/paymentIntegrityActions'),
      import('@src/middleware/actions/Reimbursement/reconsiderationAction'),
      import('@src/middleware/actions/service-interaction/callPageActions'),
      import('@src/middleware/actions/ServiceInteraction/DigitalSolutions/ediFilterActions'),
      import('@src/middleware/actions/Faq/faqActions'),
      import('@src/middleware/actions/PriorAuth/priorAuthActions'),
      import('@src/middleware/actions/IndicatorAction'),
      import('@src/apps/PriorAuth/constant'),
      import('@src/middleware/services/service-interaction/call-page.service'),
      import('@src/apps/CallSummary/CallsFilter/sessionStorageUtils'),
      import('@src/middleware/services/hiVolumeTins/hiVolumeTinsservice'),
      import('@src/middleware/services/hiVolumeTins/fetchTinGroupDetails'),
      import('@src/apps/Hitins/hiVolumeTinsFn'),
      import('@src/middleware/actions/affordabilityActions/ddpAction'),
      import('@src/middleware/actions/Ancillary/Imaging/ImagingAction'),
      import('@src/middleware/actions/SiteOfServiceAction'),
      import('@src/middleware/actions/affordabilityActions/affordabilityCommonActions'),
      import('@src/middleware/actions/ServiceInteraction/DigitalSolutions/smartEditGeoFilterActions'),
      import('@src/middleware/actions/NotificationBannerActions'),
      import('@src/middleware/actions/psms/psmsActions'),
      import('@src/middleware/actions/psms/callsChatsActions'),
      import('@src/middleware/actions/psms/claimActions'),
      import('@src/middleware/actions/psms/viewTaxIdActions'),
      import('@src/middleware/actions/psms/paymentIntegrityActions'),
      import('@src/middleware/actions/psms/digitalAdoptionActions'),
      import('@src/middleware/actions/psms/psmsPAAction'),
      import('@src/middleware/actions/psms/accountsReceivableActions'),
      import('@src/middleware/selectors/psms/psmsSelectors'),
      import('@src/middleware/selectors/claimsReportingSelector'),
      import('@src/apps/PsmsMain/Main/PsmsMainService'),
      import('@src/apps/DigitalSummary/Main/constant'),
      import('@src/apps/constants/constant'),
      // Preload common components to prevent undefined during navigation
      import('@src/CommonComponents/ModalPopupComponent/ModalPopupComponent'),
      import('@src/apps/Hitins/HiVolumeTinsComponent'),
      import('@src/apps/ModalProgress/ModalProgressBar'),
      import('@src/CommonComponents/ChangeProviderComponent/ChangeProviderComponentConnector'),
      import('@src/CommonComponents/DynamicSearchComponent/DynamicSearchComponentConnector'),
      import('@src/CommonComponents/ProviderDynamicSearchComponent/ProviderDynamicSearchComponentConnector'),
      import('@src/middleware/actions/AdvanceSearch/ASDActions'),
      import('@src/middleware/services/myInsights/myInsights.service'),
      import('@src/middleware/actions/Reimbursement/nonPaymentActions'),
      import('@src/middleware/actions/ClaimsReporting/claimsReportingActions'),
      import('@src/apps/Reimbursement/ClaimsReporting/ClaimsReporting.config'),
      import('@src/apps/Reimbursement/ClaimsReporting/ClaimsReporting.constants'),
      import('@src/apps/AiGenie/constants'),
      import('@src/apps/Reimbursement/ClaimsReporting/ClaimsReportingContext'),
      // Preload specific constants loaders to prevent undefined constants during route navigation
    ]);

  } catch (error) {
    console.error('Error preloading critical modules:', error);
  }
};
// Initialize only critical modules globally
if (typeof window !== 'undefined') {
  preloadCommonModules();
}